<template>
<!--    <div class="player" v-if="status != STOP && show" @click="jumpPage">-->
    <div class="player" v-show="false" @click="jumpPage">
        <img src="@/assets/img/ic_live.gif" alt="" class="icon" v-if="status == PLAY">
        <img src="@/assets/img/live_avatar.jpg" alt="" :class="{'cover-img': true, 'playing': status == PLAY}">
    </div>
</template>

<script>

import {mapState, mapActions} from "vuex"
import {PLAY, STOP, OTHER_VIDEO, VIRTUAL_VIDEO} from "@/global/constant";

export default {
    name: "GlobalPlayer",
    props: {
        audioType:{
            type:　String,
            default:""
        }
    },
    watch:{
      '$route'(val){
          this.show = val.name != "audioDetail"
      }
    },
    data(){
        return{
            PLAY,
            STOP,
            passTime: 0,
            hls: null,
            video: null,
            show: true
        }
    },
    computed:{
        ...mapState({
            status: state=>state.audio.status,
            audioInfo: state=>state.audio.audioInfo,
            playerEl: state=>state.audio.playerEl,
        }),
    },
    created() {
        if(!this.playerEl)this.init()
    },
    methods:{
        ...mapActions({
           "playAsync": 'audio/playAsync',
            "pauseAsync": "audio/pauseAsync",
            "stopAsync": "audio/stopAsync",
            "resumeAsync": "audio/resumeAsync",
            "initialPlayerAsync": "audio/initialPlayerAsync"
        }),
        init(){
            this.hls = new Hls()
            let video = document.createElement("audio")
            this.hls.attachMedia(video)
            this.initialPlayerAsync({el: video})
        },
        jumpPage(){
            switch (this.audioInfo.type){
                case OTHER_VIDEO:
                    this.$router.push(
                        {
                            path: "/otherAudio/detail",
                            query: {
                                id: this.audioInfo.id
                            }
                        }
                    )
                    break;
                case VIRTUAL_VIDEO:
                    this.$router.push({
                        path: "/virtual/list",
                        query: {
                            id: this.audioInfo.audioId
                        }
                    })
            }
            console.log(this.audioInfo)
        },
        play(data, onStop){
            // data.url = "https://typora-upload-img.oss-cn-chengdu.aliyuncs.com/trailer.mp4"
            if(!this.hls)this.init()
            console.log(this.hls)
            this.playAsync({
                data,
                cal: ()=>{
                    this.playerEl.src = data.url
                    this.playerEl.load()
                    // mp3不进行编译
                    // if(data.url.match(/.mp3/)){
                    //     this.playerEl.src = data.url
                    //     this.playerEl.load()
                    // }else{
                    //     this.hls.loadSource(data.url)
                    // }
                    this.playerEl.play()
                },
                onStop: onStop
            })
        },
        resume(){
            this.playerEl.currentTime = this.passTime
            this.playerEl.play()
            this.resumeAsync()
        },
        pause(){
            // 跳转到指定位置
            this.passTime = this.playerEl.currentTime
            this.playerEl.pause()
            this.pauseAsync()
        },
        // 停止播放
        stop(){
            if(!this.hls)return
            this.hls.destroy()
            this.playerEl.pause()
            this.init()
            this.stopAsync()
        },

    }
}
</script>

<style scoped lang="less">

.player{
    background-color: #fff;
    position: fixed;
    right: 0px;
    bottom: 104px;
    overflow: hidden;
    padding: 3px;
    background-color: rgba(0,0,0,.7);
    padding-right: 10px;
    display: flex;
    align-items: center;
    border-radius: 100px 0 0 100px;
    z-index: 999;
    .icon{
        width: 20px;
        height: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 999;
        transform: translate(-50%, -50%);
    }
    .cover-img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .playing{
        animation: playing linear 3s infinite;
    }

}
@keyframes playing {
    0%{
        transform: rotate(0);
    }
    100%{
        transform: rotate(360deg);
    }
}
</style>
